import { useCallback } from "react";
import * as Scrivito from "scrivito";
import { useProject } from "stores/project";
import { getHomepage } from "utils";
import type { NavigateToProductProps } from "interfaces/product/product.types";
import { useProductActions } from "stores/product";

export const useNavigateToProduct = (): ((
  props: NavigateToProductProps,
) => void) => {
  const productActions = useProductActions();
  const homepage = getHomepage();

  const productConfiguratorObj =
    homepage && typeof homepage.get === "function"
      ? (homepage.get("productConfiguratorPage") as Scrivito.Obj | null)
      : Scrivito.currentPage();

  const currentPage = Scrivito.currentPage();

  const project = useProject();

  const navigateToProduct = useCallback(
    ({ orderCode, id, kind, productName }: NavigateToProductProps): void => {
      if (!productConfiguratorObj) {
        return;
      }
      if (
        currentPage &&
        currentPage.objClass === productConfiguratorObj.objClass
      ) {
        if (!orderCode?.seriesId) {
          console.error(
            "Series ID is required to load the product in the configurator.",
          );
          return;
        }
        productActions.loadNode({
          nodeId: id,
          seriesId: orderCode?.seriesId,
        });
      }

      Scrivito.navigateTo(() => productConfiguratorObj, {
        params: {
          seriesId: String(orderCode?.seriesId),
          productId: id,
          projectId: project?.id || "",
          kind,
          productName: productName || null,
        },
      });
    },
    [productConfiguratorObj, currentPage, project?.id, productActions],
  );

  return navigateToProduct;
};
